import React, { Component } from 'react';
import { Collapse, UncontrolledCollapse, Button, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { IconLocation, IconList, IconBottom, IconFolder, ArrowBack } from '../../assets/icons/svgIcon';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import localStorageCustom from '../../utilitarios/localStorage';
import { ListarLocalesServicio, getRazonSocialAsociados } from '../../store/sagas/authApi';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

export class RazonSocial extends Component {
  static displayName = RazonSocial.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      collapse1: false,
      collapse2: false,
      asociados: [],
      lineaNegocio: {},
      asociado: {},
      dealer: {},
      // linea:{}
    };
  }


  checkParams() {
    this.setState({ loading: true });
    const { state } = this.props.location;
    let LineaNegocio = state.LineaNegocio;

    if (LineaNegocio) {
      this.setState({ lineaNegocio: LineaNegocio, loading: false })
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      const auth = this.context;
      auth.setIsLoggedIn(false);
      if (localStorageCustom.prototype.getToken() == null) {
        this.props.history.push('/');
      }
      else {
        this.checkParams();
        let data = localStorageCustom.prototype.getUsuario();
        this.setState({ dealer: data.dealer }, async () => {
          this.postRazonSocialAsociados(data.dealer, data.linea);
        });
      }
    } else
      window.location.href = "/";
  }

  render() {
    const { loading, collapse1, collapse2, asociados, asociado } = this.state;
    const navigation = this.props.navigation;
    const auth = this.context;

    return (
      <Container className="py-5" id="mhw">
        <Spinner visible={loading} />
        <Button color="link" className="btn-back"><SvgAssets icon="icon-arrow-left" className='svg' fill="#fff" /></Button>
        <h4 className="text-center title mb-4 mobile" style={{ color: '#fff' }}>Selecciona la razón social con la que desees trabajar</h4>
        <h4 className='title-2 text-center desktop' style={{ color: c.azulClaro }}>Ingresa a tu cuenta</h4>
        <div className="card card_container">
          <h6 className="title mb-5 desktop light" style={{ color: c.grisMedio }}>Selecciona la razón social con la que desees trabajar</h6>
          <Row>
            <Col md="6" xs="12">
              <h6 className="title-rs verde"><SvgAssets icon="icon-folder" fill={c.verdeClaro} />Cuenta principal</h6>
              {asociados.map((data, index) => {
                return index == 0 ? (
                  <div className="card-razon-social" key={index} >
                    <div>
                      <div className="header-collapse">
                        <div className="custom-control custom-radio custom-control-inline">
                          <input type="radio" id={`radio${data.ruc}`} name="radio_ln" className="custom-control-input" checked={asociado.ruc == data.ruc} onChange={() => this.seleccionarAsociado(data)} />
                          <label className="custom-control-label" htmlFor={`radio${data.ruc}`} style={{ color: '#2DB997' }}>{data.ruc} </label>
                        </div>
                      </div>
                      <Collapse isOpen={collapse1 === index}>
                        <div className="body-collapse">
                          <div className="item">
                            <IconList />
                            <p><span>Razón Social:</span>{data.razonsSocial}</p>
                          </div>
                          <div className="item">
                            <IconLocation />
                            <p><span>Región</span>{data.region}</p>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className="arrow-collapse" onClick={() => { collapse1 === index ? this.setState({ collapse1: null }) : this.ToggleCollapse1(index) }} style={{ background: '#2DB997' }}>
                      <SvgAssets icon={collapse1 === index ? "icon-top" : "icon-bottom"} fill={'#fff'} />
                    </div>
                  </div>
                ) : (null)
              })}
              <hr className="mobile my-4" />
            </Col>
            <Col md="6" xs="12" className="rs-border">
              <h6 className="title-rs  naranja"><SvgAssets icon="icon-folder" fill={c.naranja} />Cuentas asociadas</h6>
              {asociados.map((data, index) => {
                return index > 0 ? (
                  <div className="card-razon-social" key={index} >
                    <div>
                      <div className="header-collapse">
                        <div className="custom-control custom-radio custom-control-inline">
                          <input type="radio" id={`radio${data.ruc}`} name="radio_ln" className="custom-control-input" checked={asociado.ruc == data.ruc} onChange={() => this.seleccionarAsociado(data)} />
                          <label className="custom-control-label" htmlFor={`radio${data.ruc}`} style={{ color: '#FF9446' }}>{data.ruc} </label>
                        </div>
                      </div>
                      <Collapse isOpen={collapse2 === index}>
                        <div className="body-collapse">
                          <div className="item">
                            <IconList />
                            <p><span>Razón Social:</span>{data.razonsSocial}</p>
                          </div>
                          <div className="item">
                            <IconLocation />
                            <p><span>Región</span>{data.region}</p>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className="arrow-collapse" onClick={() => { collapse2 === index ? this.setState({ collapse2: null }) : this.ToggleCollapse2(index) }} style={{ background: '#FF9446' }}>
                      <SvgAssets icon={collapse2 === index ? "icon-top" : "icon-bottom"} fill={'#fff'} />
                    </div>
                  </div>
                ) : (null)
              })}
              {/* <div className="card-razon-social">
                <div>
                  <div className="header-collapse">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="radio2" name="radio_ln" className="custom-control-input" />
                      <label className="custom-control-label" htmlFor="radio2" style={{ color: '#FF9446' }}>9868776834</label>
                    </div>
                  </div>
                  <UncontrolledCollapse toggler="#toggler2">
                    <div className="body-collapse">
                      <div className="item">
                        <IconList />
                        <p><span>Razón Social:</span>Wunderman Thompson</p>
                      </div>
                      <div className="item">
                        <IconLocation />
                        <p><span>Región</span>Lima</p>
                      </div>
                    </div>
                  </UncontrolledCollapse>
                </div>
                <div className="arrow-collapse" id="toggler2" style={{ background: '#FF9446' }}>
                  <IconBottom />
                </div>
              </div> */}
            </Col>
          </Row>
          <div className="mobile">
            <button disabled={(!asociado.ruc)}
              className={`btn-block mt-4 red${(!asociado.ruc) ? ' disabled' : ''}`}
              onClick={() => this.postAsociado(auth.userRazonSocial, auth.setuserRazonSocial)}>
              aceptar
            </button>
            {/* <Link to="/dashboard" className="mobile" style={{ color: "#fff" }}>
              <button className='btn-block mt-4 red'>aceptar</button>
            </Link> */}
          </div>
        </div>
        <div className="desktop">
          <button disabled={(!asociado.ruc)}
            className={`desktop btn-block mt-5 red${(!asociado.ruc) ? ' disabled' : ''}`}
            onClick={() => this.postAsociado(auth.userRazonSocial, auth.setuserRazonSocial)}>
            aceptar
          </button>
        </div>
        {/* <Link to="/dashboard" className="desktop" style={{ color: "#fff" }}>
          <button className='btn-block mt-5 red'>aceptar</button>
        </Link> */}
      </Container>
    );
  }

  seleccionarAsociado = (_asociado) => {
    this.setState({ asociado: _asociado })
  }
  postAsociado = async (userRazonSocial, setuserRazonSocial) => {
    let storageGeneral = localStorageCustom.prototype.getUsuario();
    localStorageCustom.prototype.saveRazonSocial(this.state.asociado.razonsSocial);
    setuserRazonSocial(this.state.asociado.razonsSocial);
    storageGeneral.asociado = this.state.asociado;
    // storageGeneral.dealer.originalcodcliente = storageGeneral.dealer.codcliente;
    storageGeneral.dealer.codcliente = this.state.asociado.codigoDealer;
    localStorageCustom.prototype.saveUsuario(storageGeneral);

    ListarLocalesServicio(storageGeneral.dealer, storageGeneral.linea)
      .then(result => {
        if (result.mo.type == "success") {
          this.props.history.push("/dashboard");
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Asociados", error.message ?? null);
        });
      });

    // this.props.navigation.navigate('DrawerNavigator');
  }

  postRazonSocialAsociados = (dealer, linea) => {
    getRazonSocialAsociados(dealer, linea)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false, asociados: result.dto.razonSocial })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Asociados", error.message ?? null);
        });
      });
  }



  ToggleCollapse1 = (index) => {
    this.setState({ collapse1: index })
  }
  ToggleCollapse2 = (index) => {
    this.setState({ collapse2: index })
  }
}
